function checkTimerMessage() {
    if ($('#layoutCart').length > 0 && window.dataLayer.cartInfo.items > 0 && $("#checkoutCartTimer").length > 0) {
        
        if (Dillards.getFeatureFlagVariation('hideCartTimerMessage') === 'expb') {
            
            document.getElementById('checkoutCartTimer').style.display = "none";
                    
        }
    }
}

export { checkTimerMessage };